import { createAsyncThunk } from '@reduxjs/toolkit';

import type {
  IntimacaoSentencaRegistrada,
  RegistrarIntimacaoSentencaArgs,
} from '../../types/registroIntimacaoSentenca';
import { mensagemDoRegistroIntimacaoSentenca } from '../../utils/registroIntimacaoSentenca';
import { fetchPartesProcesso } from '../actions';
import { registroIntimacaoSentencaService } from './services';

/**
 * Recarrega as partes depois do registro: é de lá que sai o `podeRegistrar` que esconde a ação, e
 * a ficha com o dado velho ofereceria registrar de novo a mesma intimação (409).
 */
export const registrarIntimacaoSentencaParte = createAsyncThunk<
  IntimacaoSentencaRegistrada,
  RegistrarIntimacaoSentencaArgs,
  { rejectValue: string }
>(
  'secretariaArbitralRegistroIntimacaoSentenca/registrar',
  async (args, { dispatch, rejectWithValue }) => {
    try {
      const registrada = await registroIntimacaoSentencaService.registrar(args);
      await dispatch(fetchPartesProcesso(args.processoId));
      return registrada;
    } catch (error: unknown) {
      return rejectWithValue(mensagemDoRegistroIntimacaoSentenca(error));
    }
  },
);
